import { createFileRoute } from '@tanstack/react-router';

type Search = {
  contactId?: string;
  selectedLocationId?: string;
  templateId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/fax/drafts/new')({
  staticData: { team: 'fe-messaging' },
  validateSearch: (search: Partial<Search>): Search => {
    return {
      contactId: search.contactId,
      selectedLocationId: search.selectedLocationId,
      templateId: search.templateId,
    };
  },
});
